enum Species {
  Cat = 'Cat',
  Dog = 'Dog',
}

export default Species
